import React, { Component } from 'react';
import styled from 'styled-components';
import { Icon } from 'antd-mobile';
const StyleDiv = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    text-align: center;
`;

class Loading extends Component {
    render() {
        return (
            <StyleDiv>
                <Icon type="loading" size="sm" />
                <p>正在加载。。。</p>
            </StyleDiv>
        );
    }
}

export default Loading;
